<template>
  <div class="project-page">
    <div class="project-page__main">
      <h1>{{ pageData.title }}</h1>
      <p class="pageIngress">{{ pageData.ingress }}</p>
      <p v-if="isCommunes && pageData.disclaimer" class="pageDisclaimer">{{ pageData.disclaimer }}</p>
      <ShareAtom :lightTheme="true" />
    </div>
    <div class="project-page__main__data">
      <EntityListMolecule :data="data" />
    </div>
  </div>
</template>

<script>
import { inject, computed } from 'vue';
import ShareAtom from '../atoms/ShareAtom.vue';
import EntityListMolecule from '../molecules/EntityListMolecule.vue';
import api from '@/api/projects.js';

export default {
  components: {
    ShareAtom,
    EntityListMolecule,
  },
  setup() {
    const language = inject('language');
    const isEnglish = computed(() => language.value === 'en');

    return {
      isEnglish,
    };
  },
  data() {
    return {
      data: [],
      category: '',
      pageData: {
        title: '',
        ingress: '',
      },
    };
  },
  computed: {
    isCommunes() {
      return this.category === 'communes';
    },
  },
  methods: {
    async getCategory() {
      this.category = this.$route.name;

      if (this.category === 'projects') {
        this.pageData.title = this.isEnglish ? 'Projects' : 'Projekt';
        this.pageData.ingress = this.isEnglish
          ? 'New Swedish construction projects ranked by total emissions and emissions per square meter gross floor area. The page is continuously updated with new projects.'
          : 'Nya svenska byggprojekt rankade efter totalt utsläpp och utsläpp per kvadratmeter bruttoarea. Sidan uppdateras löpande med nya projekt.';
        this.data = await api.getProjects();
      } else if (this.category === 'communes') {
        this.pageData.title = this.isEnglish ? 'Municipalities' : 'Kommuner';
        this.pageData.ingress = this.isEnglish
          ? 'Municipalities’ construction emissions ranked by total emissions and emissions per square meter of gross floor area. The page is continuously updated with new projects.'
          : 'Kommunernas byggutsläpp rankade efter totalt utsläpp och utsläpp per kvadratmeter bruttoarea. Sidan uppdateras löpande med nya projekt.';
        this.pageData.disclaimer = this.isEnglish ? 'Municipalities with less than 1000 m² gross floor area declared are not included in this list.' : 'Kommuner med färre än 1000 m² BTA deklarerade visas inte i denna lista.';
        this.data = await api.getCommunes();
      } else if (this.category === 'builders') {
        this.pageData.title = this.isEnglish ? 'Developers' : 'Byggherrar';
        this.pageData.ingress = this.isEnglish
          ? 'Developers ranked by total emissions and emissions per square meter of gross floor area. The page is continuously updated with new projects.'
          : 'Byggherrar rankade efter totalt utsläpp och utsläpp per kvadratmeter bruttoarea. Sidan uppdateras löpande med nya projekt.';
        this.data = await api.getBuilders();
      } else if (this.category === 'building-types') {
        this.pageData.title = this.isEnglish ? 'Building types' : 'Byggnadstyper';
        this.pageData.ingress = this.isEnglish
          ? 'The total number of square meters for each building type reported by the Construction Emissions List, along with the total declared construction emissions for each type.'
          : 'Det totala antalet kvadratmeter för respektive byggnadstyp som redovisas av Byggutsläppslistan. Samt varje byggnadstyps sammanlagda deklarerade byggutsläpp.';
        this.data = await api.getBuildingTypes();
      }
    },
  },
  mounted() {
    this.getCategory();
  },
  watch: {
    $route() {
      this.getCategory();
    },
  },
};
</script>
<style scoped>
h1 {
  color: black;
  font-size: 35px;
  font-family: 'fet', sans-serif;
}
.project-page {
  background-color: white;
}
.project-page__main {
  padding: 40px 25px;
  margin-top: 30px;
}
p {
  color: black;
  font-size: 18px;
  line-height: 1;
  font-family: 'bred', sans-serif;
  font-weight: bolder;
  max-width: 40ch;
  letter-spacing: 1px;
}

.pageDisclaimer {
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0.5px;
}

@media all and (min-width: 1024px) {
  .project-page__main {
    margin-top: 50px;
    padding: 40px;
  }
  h1 {
    font-size: 50px;
  }
}
@media all and (max-width: 1024px) {
  .pageIngress {
    letter-spacing: 0.5px;
  }
}
</style>
